export default "__VITE_ASSET__C0oj6wkf__"